import React, { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getUserCreatedWorkouts, createOrDenyWorkout } from '../../features/adminWorkoutsReview/services/adminWorkoutsReviewService';
import AdminWorkoutsReviewTable from '../../features/adminWorkoutsReview/components/AdminWorkoutsReviewTable';
import AdminWorkoutsReviewBlock from '../../features/adminWorkoutsReview/components/AdminWorkoutsReviewBlock';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const AdminWorkoutsReviewPage = () => {
  const [workouts, setWorkouts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch workouts on component mount
  useEffect(() => {
    async function fetchWorkouts() {
      try {
        const data = await getUserCreatedWorkouts();
        setWorkouts(data);
      } catch (error) {
        console.error('Error fetching workouts:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchWorkouts();
  }, []);

  const handleReviewWorkout = async (updatedWorkout) => {
    try {
      await createOrDenyWorkout(updatedWorkout);

      setWorkouts((prevWorkouts) =>
        prevWorkouts.map((workout) =>
          workout.id === updatedWorkout.id
            ? { ...updatedWorkout, isReviewed: true }
            : workout
        )
      );
    } catch (error) {
      console.error('Error updating workout status:', error);
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box padding={3}>
      <Typography variant="h4" gutterBottom>
        Admin Workouts Review
      </Typography>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress />
        </Box>
      ) : isMobile ? (
        <AdminWorkoutsReviewBlock workouts={workouts} onReviewWorkout={handleReviewWorkout} />
      ) : (
        <AdminWorkoutsReviewTable workouts={workouts} onReviewWorkout={handleReviewWorkout} />
      )}
    </Box>
  );
};

export default AdminWorkoutsReviewPage;
